import useProduct from "../utils/useProduct";
import Total from "./Total";

export default function MobileFooter() {

    const product = useProduct()

    if (!product) return <></>;

    return (
        <div className="apply-mobile-footer">
            <Total />
        </div>
    );
}